import { render, staticRenderFns } from "./TagsSettingsForm.vue?vue&type=template&id=2315c5fd&scoped=true&"
import script from "./TagsSettingsForm.vue?vue&type=script&lang=js&"
export * from "./TagsSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2315c5fd",
  null
  
)

export default component.exports